import { Badge, Segmented } from 'antd';
import { sendSegmentEvent } from '../../utils/analytics';

export const SegmentedTabs = ({
  options,
  activeTab,
  setActiveTab,
  disabled,
}) => {
  const handleTabChange = (tab) => {
    sendSegmentEvent(`Switched to ${tab} Tab`);
    setActiveTab(tab);
  };

  return (
    <div className="flex justify-center items-center past">
      <Segmented
        options={(options || []).map((option) => ({
          ...option,
          label: option.showBanner ? (
            <>
              <span>{option.label}</span>
              <Badge className="absolute" dot offset={[0, 2]} />
            </>
          ) : (
            option.label
          ),
        }))}
        value={activeTab}
        onChange={(tab) => {
          handleTabChange(tab);
        }}
        disabled={disabled}
      />
    </div>
  );
};
